import { render, staticRenderFns } from "./Electives.vue?vue&type=template&id=8e81d2f4"
import script from "./Electives.vue?vue&type=script&lang=js"
export * from "./Electives.vue?vue&type=script&lang=js"
import style0 from "./Electives.vue?vue&type=style&index=0&id=8e81d2f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports